"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _dropdown = _interopRequireWildcard(require("@insided/deprecated-preact-components/design-system-components/dropdown"));

var _Search = _interopRequireDefault(require("@insided/shared/icons/Search"));

var _Close = _interopRequireDefault(require("@insided/shared/icons/Close"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var MIN_LANGUAGES_FOR_SCROLL = 6;
var MIN_LANGUAGES_FOR_SEARCH = 10;
var SCROLL_DROPDOWN_HEIGHT = '240px';
var SEARCH_DROPDOWN_HEIGHT = '280px';

var OnDemandTranslationDropdown = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(OnDemandTranslationDropdown, _Component);

  var _super = _createSuper(OnDemandTranslationDropdown);

  function OnDemandTranslationDropdown() {
    var _this;

    (0, _classCallCheck2.default)(this, OnDemandTranslationDropdown);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      searchText: ''
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "resetSearch", function () {
      return _this.setState({
        searchText: ''
      });
    });
    return _this;
  }

  (0, _createClass2.default)(OnDemandTranslationDropdown, [{
    key: "dropdownHeight",
    get: function get() {
      var languageNames = this.props.languageNames;
      if (languageNames.length >= MIN_LANGUAGES_FOR_SEARCH) return SEARCH_DROPDOWN_HEIGHT;
      if (languageNames.length >= MIN_LANGUAGES_FOR_SCROLL) return SCROLL_DROPDOWN_HEIGHT;
      return undefined;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          languageNames = _this$props.languageNames,
          onDemandTranslation = _this$props.onDemandTranslation,
          trigger = _this$props.trigger;
      var searchText = this.state.searchText;
      var showSearch = languageNames.length >= MIN_LANGUAGES_FOR_SEARCH;
      var visibleLanguages = showSearch ? languageNames.filter(function (lang) {
        return lang.toLowerCase().includes(searchText.toLowerCase());
      }) : languageNames;
      return (0, _preact.h)(_dropdown.default, {
        size: "full-width",
        align: "left",
        position: "bottom",
        trigger: (0, _preact.h)("button", {
          className: "on-demand-translation-trigger-wrapper",
          tabIndex: -1,
          onClick: this.resetSearch
        }, trigger),
        popupName: "language-selector-dropdown",
        closeOnDropdownClick: true,
        customHeight: this.dropdownHeight
      }, showSearch && (0, _preact.h)("li", {
        className: "on-demand-translation-searchbox-wrapper"
      }, (0, _preact.h)("div", {
        className: "on-demand-translation-searchbox"
      }, (0, _preact.h)(_Search.default, {
        width: 16,
        height: 16
      }), (0, _preact.h)("input", {
        type: "text",
        placeholder: "Search",
        value: searchText,
        onInput: function onInput(e) {
          return _this2.setState({
            searchText: e.currentTarget.value
          });
        }
      }), searchText && (0, _preact.h)(_Close.default, {
        className: "on-demand-translation-searchbox__clear",
        onClick: function onClick(e) {
          e.stopPropagation();

          _this2.resetSearch();
        }
      }))), visibleLanguages.map(function (lang) {
        return (0, _preact.h)(_dropdown.DropdownItem, {
          key: lang,
          onClick: function onClick() {
            return onDemandTranslation(lang);
          }
        }, lang);
      }));
    }
  }]);
  return OnDemandTranslationDropdown;
}(_preact.Component);

var _default = OnDemandTranslationDropdown;
exports.default = _default;